module.exports = __webpack_public_path__ + "static/media/mssd.3196b27a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/mssd.png
// module id = 646
// module chunks = 0